import { BizSelectOwner } from 'src/components/biz-select-owner';

export default BizSelectOwner;
